import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, HostListener, Input, OnChanges, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { PAGE_TYPE } from 'src/app/core/constants/page-type.enum';
import { REQUEST_STATUS } from 'src/app/core/constants/request-status.enum';
import { TuwaiqConfig } from 'src/app/core/constants/tuwaiq.config';

import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SmsCallRecordComponent } from 'src/app/call-record-management/ui/sms-call-record/sms-call-record.component';
import { RouterPathConfig } from 'src/app/core/constants/router-path.config';
import { VIEW_TYPE } from 'src/app/core/constants/view-type.enum';
import { DataDetails } from 'src/app/core/models/data-details.model';
import { ViewDetails } from 'src/app/core/models/view-details.model';
import { ApiRequestService } from 'src/app/core/services/api-request.service';
import { LoggedInUserService } from 'src/app/core/services/logged-in-user.service';
import { ParamHandlerService } from 'src/app/core/services/param-handler.service';
import { RequestViewService } from 'src/app/core/services/request-view.service';
import { RoutingHandlerService } from 'src/app/core/services/routing-handler.service';
import { SidebarMenuService } from 'src/app/core/services/sidebar-menu.service';
import { AuditReportStatuses } from 'src/app/periodic-review/enums/audit-report.enum';
import { REPORT_STATUS_IDS } from 'src/app/periodic-review/enums/report-status.enum';
import { REPORT_TYPE } from 'src/app/periodic-review/enums/report-type.enum';
import { DialogDataService } from 'src/app/periodic-review/services/dialogDataService.service';
import { PeriodicModuleService } from 'src/app/periodic-review/services/report-module.service';
import { CommentsReportsComponent } from 'src/app/periodic-review/ui/comments/comments.component';
import { ServiceModuleService } from 'src/app/service/data-access/service-module.service';
import { HistoryServiceComponent } from 'src/app/service/feature/service-details/components/history-service/history-service.component';
import { TicketStatus } from 'src/app/service/util/enums/ticket-status.enum';
import { TicketingService } from 'src/app/ticketing/data-access/ticketing.service';
import { DynamicModalComponent } from '../../dynamic-modal/dynamic-modal.component';

@Component({
    selector: 'app-table-to-cards',
    templateUrl: './table-to-cards.component.html',
    styleUrls: ['./table-to-cards.component.scss', '../../../../../assets/css/request-status-colors.css']
})
export class TableToCardsComponent implements OnChanges {
    @Input() data: DataDetails;
    @Input() displayedColumns;
    @Input() columns;
    @Input() pageType: PAGE_TYPE;
    @Input() viewType: VIEW_TYPE;
    @Input() showSelectionView: boolean;
    @Input() userRole;
    @Input() hideClientFilter: boolean | undefined;
    @Input() userId;
    @Input() reportTabId;
    @Input() deviceId;
    pageData: any;
    showErrorState = false;
    showEmptyState = false;
    showLoader = false;
    page;
    pageSize = TuwaiqConfig.PAGINATION_CONFIG.DEFAULT_PAGE_SIZE_TICKETING_MODULE;
    collectionSize;
    paginationSize = 'sm';
    refreshData = false;
    currentPage = 1;

    public viewTypes = VIEW_TYPE;

    checkedItemsList = [];
    selection = new SelectionModel<any>(true, []);

    @Output() displayActionBtn = new EventEmitter<any>();
    @Output() OnDeleteItem: EventEmitter<any> = new EventEmitter<any>();
    historySectionData: any;
    isLoading: boolean;
    serviceId?: string;
    @Input() reportType;
    @Output() OnPageChange: EventEmitter<any> = new EventEmitter<any>();
    report = VIEW_TYPE.REPORT;
    auditReportStatuses = AuditReportStatuses;
    auditReportStatusesId = REPORT_STATUS_IDS;

    activeTooltipRowId: number | null = null;

    @Output() downloadPdfRequest = new EventEmitter<number>();
    @Output() downloadExcelRequest = new EventEmitter<number>();
    @Output() downloadWordRequest = new EventEmitter<number>();

    @Output() downloadPdfDeviceRequest = new EventEmitter<number>();
    @Output() downloadExcelDeviceRequest = new EventEmitter<number>();
    viewDetails: ViewDetails;
    inprogressRequestView = VIEW_TYPE.INPROGRESS_REQUESTS;
    completedRequestView = VIEW_TYPE.COMPLETED_REQUESTS;
    dashboardRequestView = VIEW_TYPE.DASHBOARD;
    employeeManagementRequestView = VIEW_TYPE.EMPLOYEE_MANAGEMENT_REQUESTS;
    securityCoordinatorRequestView = VIEW_TYPE.SECURITY_COORDINATOR_REQUESTS;
    technicalOperationsRequestsView = VIEW_TYPE.TECHNICAL_OPERATIONS_REQUESTS;

    @HostListener('document:click', ['$event'])
    onClickOutside(event: MouseEvent) {
        this.activeTooltipRowId = null;
    }

    constructor(
        private requestsService: RequestViewService,
        private ticketingService: TicketingService,
        private apiRequestService: ApiRequestService,
        private sidebarMenuService: SidebarMenuService,
        private route: ActivatedRoute,
        private paramHandlerService: ParamHandlerService,
        public translateService: TranslateService,
        private routingHandlerService: RoutingHandlerService,
        private _router: Router,
        private serviceModuleService: ServiceModuleService,
        public dialog: MatDialog,
        private dialogDataService: DialogDataService,
        public periodicReviewService: PeriodicModuleService,
        private toastr: ToastrService,
        private loggedInUserService: LoggedInUserService,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnChanges(): void {
        console.log(this.viewType);
        this.setDataDetails();
        this.setDataSourceAndColumns();
    }

    private updateStatus(): void {
        for (let i = 0; i <= this.pageData?.length; i++) {
            if (this.pageData[i]?.status) {
                this.pageData[i].status = TicketStatus[this.pageData[i].status] || this.pageData[i].status;
            }
        }
    }
    setDataDetails() {
        this.collectionSize = this.data?.totalElements;
        this.page = this.data?.currentPage;

        this.refreshData = this.data?.filterResults ? false : true;

        if (this.viewType === VIEW_TYPE.DASHBOARD) {
            this.pageSize = TuwaiqConfig.PAGINATION_CONFIG.DASHBOARD_DEFAULT_PAGE_SIZE;
        }
        if (this.pageType === PAGE_TYPE.REQUESTS) {
            this.pageSize = TuwaiqConfig.PAGINATION_CONFIG.DEFAULT_PAGE_SIZE;
        }
    }

    setDataSourceAndColumns() {
        this.setEmptyAndErrorStateVariables(false, false);

        // converting the data type from table to other
        this.pageData = this.data?.dataList as any;
        this.updateStatus();

        // this.tableDisplayedColumns = this.displayedColumns;
        // this.dataSource = new MatTableDataSource<any>(this.dataDetails.dataList);

        this.handleEmptyAndErrorState();
    }

    handleEmptyAndErrorState() {
        if (!this.data?.dataList) {
            // this.isLoading=false;
            this.setEmptyAndErrorStateVariables(false, false);
            // } else if (this.data.dataList.length === 0) {
        } else if (this.data?.dataList.length === 0) {
            this.setEmptyAndErrorStateVariables(true, false);
            //this.isLoading=false;
        }
    }

    setEmptyAndErrorStateVariables(isEmptyState, isErrorState) {
        this.showEmptyState = isEmptyState;
        this.showErrorState = isErrorState;
    }

    onPageChange(currentPage) {
        if (this.pageType === PAGE_TYPE.REQUESTS) {
            this.clearSelection();
        }
        this.currentPage = currentPage;
        this.requestsService.scrollToTop.next(true);
        if (
            this.viewType === this.viewTypes.CALL_RECORD ||
            this.viewType === this.viewTypes.REPORT ||
            this.viewType === this.viewTypes.SHARED_REPORTS ||
            this.viewType === this.viewTypes.CALL_CENTER_CLIENT_REQUEST
        ) {
            this.OnPageChange.emit(currentPage);
        }
        if (this.pageType === PAGE_TYPE.TICKETING) {
            this.ticketingService.fetchNextPage.next(currentPage);
            this.serviceModuleService.fetchNextPage.next(currentPage);
        } else {
            this.requestsService.fetchNextPage.next(currentPage);
        }
    }

    onCardClick(row, viewType) {
        this.dialogDataService.clearData();
        if (this.viewType === this.viewTypes.REPORT || this.viewType === this.viewTypes.SHARED_REPORTS) {
            if (this.reportType === REPORT_TYPE.AUDIT) {
                this._router.navigate(['/periodic-review/report/' + row.id]);
            } else if (this.reportType === REPORT_TYPE.DEVICES) {
                if (this.reportTabId === 1) {
                    this._router.navigate(['/periodic-review/report-device-details/' + row.id], { queryParams: { viewType } });
                } else {
                    this._router.navigate(['/periodic-review/device/' + row.id]);
                }
            }
            // this._router.navigate(['/periodic-review/report/'+row.id]);
        } else if (this.viewType === this.viewTypes.CALL_RECORD) {
            const callRecordId = row.id;
            const userRole = this.loggedInUserService.getUserRole();
            this.viewDetails = this.sidebarMenuService.getViewObject();
            const userRequestPath = this.routingHandlerService.getUserAndRequestPath(userRole, this.viewDetails);
            this._router.navigate([userRequestPath, RouterPathConfig.VIEW_CALL_RECORD_PATH, callRecordId], {});
        } else if (this.viewType === this.viewTypes.CALL_CENTER_CLIENT_REQUEST) {
            this._router.navigate(['/call-center-client-management/request-list/' + row.id]);
        } else if (this.viewType === this.viewTypes.E_SERVICE) {
            // Check if we're in delegation view
            const isDelegationView = this.activatedRoute.snapshot.data && this.activatedRoute.snapshot.data['delegationView'];

            if (isDelegationView) {
                // Navigate to details within delegation module
                const routePrefix = '/delegation/details-service';
                this._router.navigate([`${routePrefix}/${row.id}`], { queryParams: { isDelegate: isDelegationView } });
            } else {
                // Standard navigation
                this.onRowClick(row);
            }
        } else {
            if (this.pageType === PAGE_TYPE.TICKETING) {
                return;
            }
            // only run this if page type is not ticketing
            const requestId = row.id;
            const viewObject = this.sidebarMenuService.getViewObject();
            this.paramHandlerService.clearFilterParamList();
            this.routingHandlerService.navigateToRequestDetailsView(requestId, viewObject, this.route);
        }
    }

    onToggleAllRowsChangeEvent(event) {
        this.handleCheckItemsOnToggleAll();
        this.handleSelectionListAndActionBtn();
        return event ? this.toggleAllRows() : null;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    toggleAllRows() {
        if (this.isAllSelected()) {
            this.selection.clear();
            return;
        }

        this.selection.select(...this.data.dataList);
    }

    clearSelection() {
        if (this.isAllSelected()) {
            this.selection.clear();
            this.checkedItemsList = [];
        }
    }

    handleCheckItemsOnToggleAll() {
        if (this.isAllSelected()) {
            this.checkedItemsList = [];
        } else {
            this.checkedItemsList = [];
            this.checkedItemsList.push(...this.data.dataList);
        }
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.data.dataList ? this.data.dataList.length : 0;
        return numSelected === numRows;
    }

    checkboxLabel(row?: any): string {
        if (!row) {
            return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.requestNumber + 1}`;
    }

    onRowChangeEvent(event, row) {
        this.trackCheckedItems(event, row);
        this.handleSelectionListAndActionBtn();
        return event ? this.selection.toggle(row) : null;
    }

    trackCheckedItems(event, row) {
        const index = this.checkedItemsList.findIndex(v => v.id === row.id);
        if (event.checked && index === -1) {
            this.checkedItemsList.push(row);
        } else {
            this.checkedItemsList.splice(index, 1);
        }
    }

    getRowStatus(row) {
        if (row && row.status) {
            if (row.status === REQUEST_STATUS.OPEN_REQUEST_STATUS || row.status === REQUEST_STATUS.OPERATION_OPEN_REQUEST_STATUS) {
                return 'new';
            } else if (row.status === REQUEST_STATUS.RETURNED_REQUEST_STATUS) {
                return 'returned';
            } else if (row.status === REQUEST_STATUS.INPROGRESS_REQUEST_STATUS || row.status === REQUEST_STATUS.OPERATION_INPROGRESS_REQUEST_STATUS) {
                return 'inprogress';
            } else if (
                row.status === REQUEST_STATUS.CLOSED_REQUEST_STATUS ||
                row.status === REQUEST_STATUS.OPERATION_COMPLETED_REQUEST_STATUS ||
                row.status === REQUEST_STATUS.OPERATION_COMPLETED_HISTORY_REQUESTS
            ) {
                return 'completed';
            } else {
                return '';
            }
        } else return '';
    }

    handleSelectionListAndActionBtn() {
        if (this.checkedItemsList.length && this.checkedItemsList.length > 0) {
            this.displayActionBtn.emit(true);
        } else if (this.checkedItemsList.length === 0) {
            this.displayActionBtn.emit(false);
        }

        const selectedRequestsIdList = this.checkedItemsList.map(v => v.id);
        this.requestsService.storeSelectedRequests(selectedRequestsIdList);
    }

    onRetryBtnClick() {
        this.requestsService.onReloadRequests.next(true);
    }

    onRefreshBtnClick() {
        this.requestsService.onReloadRequests.next(true);
    }
    onRowClick(item) {
        // Check if we're in delegation view
        const isDelegationView = this.activatedRoute.snapshot.data && this.activatedRoute.snapshot.data['delegationView'];

        if (isDelegationView) {
            // Navigate to details within delegation module
            const routePrefix = '/delegation/details-service';
            this._router.navigate([`${routePrefix}/${item.id}`], { queryParams: { isDelegate: isDelegationView } });
        } else {
            const routePrefix = '/services/details-service';
            // this.userRole === USER_ROLE.REQUESTER ? '/services/details-service' : '/services/service-details';
            this._router.navigate([`${routePrefix}/${item.id}`], { queryParams: { isDelegate: isDelegationView } });
        }
    }
    onDeleteItem(item) {
        this.OnDeleteItem.emit(item);
    }
    onHistoryRowClick(item, event: MouseEvent) {
        event.stopPropagation();
        this.getAllHistoryServices(item);
    }
    onCommentItem(item, event: MouseEvent, isAdding) {
        event.stopPropagation(); // Prevent event from bubbling up to parent

        if (this.userId !== item.creatorId) {
            isAdding = false;
        }
        this.dialogDataService.setData({
            disableClose: false,
            data: {
                reportId: item.id,
                textHeder: 'auditorComments',
                dialog: true,
                commentType: 'commentTypeAuditor',
                isAdding: isAdding,
                viewType: this.viewType
            }
        });

        this.dialog.open(CommentsReportsComponent);
    }

    onCommentDeviceReportIconClick(item) {
        this.dialogDataService.setData({
            disableClose: false,
            data: {
                reportId: item.id,
                textHeder: 'auditorComments',
                dialog: true,
                commentType: 'commentTypeAuditor',
                isAdding: false,
                isReportDevice: true,
                viewType: this.viewType
            }
        });

        this.dialog.open(CommentsReportsComponent);
    }
    onExportItem(item) {}
    getAllHistoryServices(row) {
        this.serviceId = row.id;
        this.isLoading = true;
        this.serviceModuleService.getHistoryEService(this.serviceId).subscribe(
            (response: any) => {
                const historyData = response?.body?.data;
                // removing the last item of the history since it is not needed
                historyData?.ticketActions?.pop();

                historyData.ticketActions = historyData?.ticketActions
                    .filter(m => m.ticketOldStatus !== undefined)
                    .map(item => {
                        const oldStatus = TicketStatus[item.ticketOldStatus];
                        const actionDescription = TicketStatus[item.actionDescription];
                        if (actionDescription !== undefined) {
                            item.actionDescription = actionDescription;
                        }
                        if (oldStatus !== undefined) {
                            item.ticketOldStatus = oldStatus;
                            item.ticketNewStatus = TicketStatus[item.ticketNewStatus];
                        }
                        return item;
                    });
                this.historySectionData = historyData;
                this.openHistoryModal(row);
                this.isLoading = false;
            },
            error => {
                this.isLoading = false;
            }
        );
    }
    openHistoryModal(row) {
        const dialogRef = this.dialog.open(DynamicModalComponent, {
            width: '800px',
            height: '500px',
            autoFocus: false,
            data: {
                title: 'historyServiceTitle',
                headerBg: false,
                component: HistoryServiceComponent,
                inputs: { historyData: this.historySectionData, prefixTicketCode: row?.number }
            }
        });
        dialogRef.afterClosed().subscribe(confirm => {
            {
            }
        });
    }

    toggleTooltip(rowId: number, event: MouseEvent) {
        event.stopPropagation();

        console.log('Emitting PDF request for rowId:', rowId);

        if (this.activeTooltipRowId === rowId) {
            this.activeTooltipRowId = null;
        } else {
            this.activeTooltipRowId = rowId;
        }
    }

    downloadExcelFile(row: any, event: MouseEvent) {
        event.stopPropagation();

        this.downloadExcelRequest.emit(row);
        this.activeTooltipRowId = null;
    }

    downloadPDF(row: any, event: MouseEvent) {
        event.stopPropagation();

        this.downloadPdfRequest.emit(row);
        this.activeTooltipRowId = null;
    }
    downloadWordFile(row: any, event: MouseEvent) {
        event.stopPropagation();

        this.downloadWordRequest.emit(row);
        this.activeTooltipRowId = null;
    }

    downloadExcelDevice(row: any, event: MouseEvent) {
        event.stopPropagation();

        this.downloadExcelDeviceRequest.emit(row);
        this.activeTooltipRowId = null;
    }

    downloadPDFDevice(row: any, event: MouseEvent) {
        event.stopPropagation();

        this.downloadPdfDeviceRequest.emit(row);
        this.activeTooltipRowId = null;
    }
    onSmsClick(item, event: MouseEvent) {
        event.stopPropagation(); // Prevent event from bubbling up to parent

        this.dialog.open(SmsCallRecordComponent, { disableClose: true, data: { callRecordId: item.id } });
    }
}
